/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Host } from '../models/Host';
import type { VanliferErrorResponse } from '../models/VanliferErrorResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserHostService {
    /**
     * Get a host by id
     * @param hostId
     * @returns Host OK
     * @throws ApiError
     */
    public static getHost(
        hostId: number,
    ): CancelablePromise<Host> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/hosts/{hostId}',
            path: {
                'hostId': hostId,
            },
        });
    }
    /**
     * Update an existing host by id
     * @param hostId
     * @param requestBody
     * @returns Host OK
     * @throws ApiError
     */
    public static updateHost(
        hostId: number,
        requestBody: Host,
    ): CancelablePromise<Host> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/users/hosts/{hostId}',
            path: {
                'hostId': hostId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete a host
     * @param hostId
     * @returns VanliferErrorResponse OK
     * @throws ApiError
     */
    public static deleteHost(
        hostId: number,
    ): CancelablePromise<VanliferErrorResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/users/hosts/{hostId}',
            path: {
                'hostId': hostId,
            },
        });
    }
    /**
     * Create a new host user
     * @param requestBody
     * @returns Host OK
     * @throws ApiError
     */
    public static createHostUser(
        requestBody: Host,
    ): CancelablePromise<Host> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/users/hosts',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
